import "@mantine/core/styles.css";
import "@mantine/code-highlight/styles.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MantineProvider } from "@mantine/core";

import { Application } from "./application.tsx";

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// Root Element
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element not found!");
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// Render Application
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

createRoot(root).render(
  <StrictMode>
    <MantineProvider>
      <Application />
    </MantineProvider>
  </StrictMode>,
);
